<div class="ResPonsiveHighet" [style.height]="this.autoiPadHeightFunc()">
  <gridster *ngIf="widgets.length"
      [options]="options"
      class="pt-2 pb-3 du-gridster-grid-component"
      id="gridster">

    <div *ngIf="deviceDetectionService.isTablet || deviceDetectionService.isMobile"
        style="min-height: 10px; height: auto; position: relative;">

      <app-text-notes *ngIf="textNotesWidget" [item]="textNotesWidget!"></app-text-notes>

      <div class="d-flex justify-content-end px-3" *ngIf="widgetService.alertIcon || widgetService.filterIcon">
        <app-alert-button *ngIf="widgetService.alertIcon"></app-alert-button>
        <app-filter-button *ngIf="widgetService.filterIcon"></app-filter-button>
      </div>

      <!-- COMMON WIDGETS LIKE FILTER, TIME CYCLE, INFORMATION ICON -->
      <div *ngIf="commonWidgets.length" class="d-flex align-items-center" style="padding: 5px 15px 5px 15px;">
        <ng-container *ngFor="let widget of commonWidgets">
          <ng-container [app-widget]="{ item: widget, pageKey: pageInfo.page_key }"></ng-container>
        </ng-container>
      </div>

      <!-- KPI CARDS AND PRESCRIBER CARD -->
      <div *ngIf="kpiCardWidgets.length || informationCardWidgets.length"
          class="horizontal-scrollable"
          style="margin-left: 10px;">
        <div class="row text-center flex-nowrap overflowXAuto" style="padding: 10px">
          <div *ngFor="let widget of informationCardWidgets"
              class="cardss"
              [style.height]="showLessMore ? 'auto' : '125px'">
            <ng-container [app-widget]="{ item: widget, pageKey: pageInfo.page_key }"></ng-container>
          </div>

          <div *ngFor="let widget of kpiCardWidgets"
            #ssss
              [class.cards-auto-width]="widget.key === 100103"
              [class.cards-content-width]="widget.key === 100805"
              [style.width]="widget.key === 100103 || widget.key === 100805 ? null : widget.key === 100107 ? '300px' : '250px'"
              class="cards mb-1">
            <ng-container [app-widget]="{ item: widget, pageKey: pageInfo.page_key }"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- One tile. Declared inside <gridster> so the gridster-item it stamps finds its grid. -->
    <ng-template #tile let-widget>
      <gridster-item
        [item]="widget"
        [ngClass]="{
            highlight: !keysByType.nonHighlight.includes(widget.key)
        }"
        [class.du-bottom-spacer]="widget === bottomSpacer"
        [class.du-card-wide]="widget.key === 100107"
        [class.du-card-auto]="widget.key === 100103 || widget.key === 100805"
        class="heightClass"
        [style.visibility]="!keysByType.visibilityHidden.includes(widget.key) ? 'block' : 'hidden'"
        #gridsterItemsss
      >
        <ng-container [app-widget]="{ item: widget, height: gridsterItemsss, pageKey: pageInfo.page_key }"
            (onSizeChange)="resize(widget, $event)"></ng-container>
      </gridster-item>
    </ng-template>

    <!-- The desktop KPI / information card tiles. display: contents keeps this wrapper out of
         gridster's layout, so they are ordinary tiles - until a narrow window puts gridster in
         its mobile mode (narrowGrid), which stacks every tile full width and collapsed the
         cards. Then this wrapper becomes the same scrolling card row tablets get. The tiles
         stay the same elements either way, so the cards never reload. -->
    <div class="du-card-strip" [class.du-card-strip-narrow]="narrowGrid">
      <ng-container *ngFor="let widget of cardTiles">
        <ng-container *ngTemplateOutlet="tile; context: { $implicit: widget }"></ng-container>
      </ng-container>
    </div>
    <ng-container *ngFor="let widget of otherTiles">
      <ng-container *ngTemplateOutlet="tile; context: { $implicit: widget }"></ng-container>
    </ng-container>
  </gridster>

  <app-alerts-tab></app-alerts-tab>
  <app-dynamic-filter [item]="filterWidgetConfig"></app-dynamic-filter>
</div>

<app-loader-component *ngIf="showLoader"></app-loader-component>